import stateOptions from '../options/state';
import genderOptions from '../options/gender';

const updateManagerFields = {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  email: {
    value: '',
    error: null,
    name: 'email',
    placeholder: 'Email Address',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'email',
    hasBlurred: false,
    inputType: 'text',
  },
};

export default updateManagerFields;



/** WEBPACK FOOTER **
 ** ./src/forms/manager/update.js
 **/